/**
 * Applies create-path defaults for records extending the shared base entity.
 */
export function applyBaseEntityCreateDefaults<
  T extends {
    isExcludedFromReports?: boolean | null;
    isExcludedFromAggregators?: boolean | null;
  },
>(record: T): T {
  record.isExcludedFromReports = record.isExcludedFromReports ?? false;
  record.isExcludedFromAggregators = record.isExcludedFromAggregators ?? false;

  return record;
}
